<template>
  <div
    :class="[
      $style.statusMarker,
      $style[`statusMarkerColor--${state}`],
      {
        [$style.statusMarkerNoPadding]: noPadding,
      },
    ]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
  import type { AwStatusMarkerState } from '~~/common/config/AwStatusMarker';

  withDefaults(defineProps<{
    state: AwStatusMarkerState;
    noPadding?: boolean;
  }>(), {
    state: 'success',
    noPadding: false,
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.statusMarker {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  text-align: center;
  border-radius: 8px;
  gap: 8px;

  &:not(.statusMarkerNoPadding) {
    padding: 6px 8px;

    @include tablet(min) {
      padding: 6px 12px;
    }
  }

  &Color {
    &--success {
      color: $color-notification-success-text;
      background: $color-notification-success--12;
    }

    &--pending {
      color: $color-notification-warning-text;
      background: $color-notification-warning--12;
    }

    &--warning {
      color: $color-warning-text;
      background: $color-background-warning;
    }

    &--error {
      color: $color-notification-error-text;
      background: $color-notification-error--12;
    }

    &--info {
      color: $color-notification-info-text;
      background: $color-notification-info--12;
    }

    &--neutral {
      color: $color-text-secondary;
      background: $color-olive-750--12;
    }
  }
}
</style>
